export function Spinner() {
  return (
    <div className="flex justify-center my-4">
      <div className="w-8 h-8 border-4 border-blue-400 border-dashed rounded-full animate-spin"/>
    </div>
  );
}
